import React from 'react'
import { Badge } from 'react-bootstrap'

const Participants = ({
    users = []
}) => {

    const renderUser = (user) => {
        return (
            <div
                key={user.id}
                style={{
                    display: 'inline-block',
                    paddingLeft: '3px'
                }}
            >
                <Badge variant='secondary' >{user.firstName} {user.lastName}</Badge>
            </div>
        )
    }

    return (
        <React.Fragment>
            {users.map(renderUser)}
        </React.Fragment>
    )
}

export default Participants
